export function flattenObject(ob: any) {
  return flattenObjectWithSeparator(ob, '.');
}

export function flattenObjectWithSeparator(ob: any, separator = '.') {
  let toReturn = {} as any;
  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) {
      continue;
    }
    if (typeof ob[i] == 'object') {
      let flatObject = flattenObjectWithSeparator(ob[i], separator);
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) {
          continue;
        }
        toReturn[i + separator + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
}
